export default __webpack_public_path__ + "static/media/arrow-light-mode.34c94afa.svg";